import DataFormNew from '../../../components/common/DataFormNew'
import SectionContainer from '../../../components/common/SectionContainer'

const inputs = [
    {
        key: 'name',
        label: 'Name',
        required: true,
    },
]

export default function CreateCustomLocation() {
    return (
        <>
            <SectionContainer>
                <DataFormNew
                    url={`/v1/shop/locations`}
                    submitText="Save"
                    submitToast="Saved"
                    submitNavArg={`/settings/custom-locations`}
                    inputs={inputs}
                    mutationRegexes={[/\/v1\/shop\/locations/]}
                    mainButton
                    getBody={(data) => ({
                        name: data.name,
                        shopifyShopId: 'null',
                    })}
                />
            </SectionContainer>
        </>
    )
}
